import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hub-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
